import jsPDF from 'jspdf';
import 'jspdf-autotable';
import pdfMake from 'pdfmake/build/pdfmake';


// Función para fecha corta en español
function fechaCorta(fecha) {
  if (!fecha) return '-';
  const date = new Date(fecha);
  return date.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' });
}

// Traducción de membresía
function traducirMembresia(tipo) {
  switch (tipo) {
    case 'basic': return 'Básica';
    case 'premium': return 'Premium';
    case 'vip': return 'VIP';
    case 'Familia Pequeña': return 'Familia Pequeña';
    case 'Familia Grande': return 'Familia Grande';
    default: return tipo;
  }
}

// Traducción de estado
function traducirEstado(estado) {
  switch (estado) {
    case 'active': return 'Activo';
    case 'expired': return 'Expirado';
    case 'pending': return 'Pendiente';
    case 'completed': return 'Completado';
    case 'overdue': return 'Vencido';
    default: return estado;
  }
}

// Traducción de método de pago
function traducirMetodo(metodo) {
  if (!metodo) return '-';
  switch (metodo.toLowerCase()) {
    case 'wechat': return 'WeChat Pay';
  case 'alipay': return 'Efectivo';
    case 'bank': return 'Transferencia Bancaria';
    case 'cash': return 'Efectivo';
    case 'card': return 'Tarjeta';
    case 'paypal': return 'PayPal';
    default: return metodo;
  }
}

// Traducción de tipo de evento
function traducirEvento(tipo) {
  switch (tipo) {
    case 'birthday': return 'Cumpleaños';
    default: return tipo;
  }
}

// Traducción de tipo de recordatorio
function traducirRecordatorio(tipo) {
  switch (tipo) {
    case 'payment_due': return 'Vencimiento de Pago';
    case 'birthday': return 'Cumpleaños';
    default: return tipo;
  }
}

// Exportación de miembros usando pdfmake (soporta chino)
export const generateMembersPdf = (members, filtros = null) => {
  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text('Reporte de Socios', 14, 22);
  
  // Agregar información de filtros si existen
  let startY = 28;
  if (filtros) {
    doc.setFontSize(10);
    doc.setTextColor(100);
    let yPos = 30;
    
    doc.text(`Fecha: ${new Date().toLocaleDateString('es-ES')}`, 14, yPos);
    yPos += 5;
    doc.text(`Total de registros: ${filtros.total}`, 14, yPos);
    
    if (filtros.estado || filtros.membresia || filtros.busqueda) {
      yPos += 5;
      const filtrosTexto = [];
      if (filtros.estado) filtrosTexto.push(`Estado: ${filtros.estado}`);
      if (filtros.membresia) filtrosTexto.push(`Membresía: ${filtros.membresia}`);
      if (filtros.busqueda) filtrosTexto.push(`Búsqueda: ${filtros.busqueda}`);
      doc.text(`Filtros: ${filtrosTexto.join(', ')}`, 14, yPos);
    }
    
    startY = yPos + 8;
    doc.setTextColor(0);
  }

  const tableColumn = ["RUT", "Nombre", "Email", "Teléfono", "Membresía", "Estado", "Fecha de Ingreso"];
  const tableRows = [];

  members.forEach(member => {
    tableRows.push([
      member.rut || '-',
      member.name,
      member.email,
      member.phone,
      traducirMembresia(member.membershipType),
      traducirEstado(member.status),
      fechaCorta(member.joinDate),
    ]);
  });

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: startY,
    styles: {
      fontSize: 10,
      halign: 'center',
      valign: 'middle',
      cellPadding: 3,
      textColor: [44, 62, 80],
    },
    headStyles: {
      fillColor: [236, 239, 241], // gris claro
      textColor: [44, 62, 80], // gris oscuro
      fontStyle: 'bold',
      fontSize: 11,
    },
    alternateRowStyles: {
      fillColor: [245, 245, 255], // azul muy claro
    },
    rowStyles: {
      minCellHeight: 10,
    },
    theme: 'grid',
    margin: { left: 10, right: 10 },
  });

  doc.save(`reporte_socios_${new Date().toISOString().slice(0,10)}.pdf`);
};

// Exportación de pagos con jsPDF/autotable
export const generatePaymentsPdf = (payments, totalFiltrado = null, members = []) => {
  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text('Reporte de Pagos de Membresía', 14, 22);

  const tableColumn = ["ID", "Socio", "Membresía", "Monto", "Estado", "Fecha de Pago", "Fecha de Vencimiento", "Método"];
  const tableRows = [];

  payments.forEach(payment => {
    // Obtener el tipo de membresía actual del socio
    const member = members.find(m => m.id === payment.memberId);
    const currentMembershipType = member?.membershipType || payment.membershipType;
    
    const paymentData = [
      payment.id,
      payment.memberName,
      traducirMembresia(currentMembershipType),
  `$${parseFloat(payment.amount).toLocaleString('es-ES')}`,
      traducirEstado(payment.status),
      fechaCorta(payment.paymentDate),
      fechaCorta(payment.dueDate),
      traducirMetodo(payment.paymentMethod),
    ];
    tableRows.push(paymentData);
  });

  // Agregar fila de total si se proporciona
  if (totalFiltrado !== null) {
    tableRows.push([
      '',
      '',
      '',
      `$${totalFiltrado.toLocaleString('es-ES')}`,
      '',
      '',
      '',
      'TOTAL FILTRADO'
    ]);
  }

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 30,
    theme: 'grid',
    styles: {
      font: 'helvetica',
      fontSize: 10,
      cellPadding: 3,
      overflow: 'linebreak',
      halign: 'left',
      valign: 'middle'
    },
    headStyles: {
      fillColor: [240, 240, 240],
      textColor: [0, 0, 0],
      fontStyle: 'bold'
    },
    alternateRowStyles: {
      fillColor: [249, 249, 249]
    }
  });
  doc.save(`reporte_pagos_${new Date().toISOString().slice(0,10)}.pdf`);
};

// Exportación de donaciones con jsPDF/autotable
export const generateDonationsPdf = (donations, totalFiltrado = null) => {
  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text('Reporte de Donaciones', 14, 22);

  const tableColumn = ["ID", "Donante", "Monto", "Fecha", "Método", "Notas"];
  const tableRows = [];

  donations.forEach(donation => {
    const donationData = [
      donation.id,
      donation.donorName,
  `$${parseFloat(donation.amount).toLocaleString('es-ES')}`,
      fechaCorta(donation.donationDate),
      traducirMetodo(donation.paymentMethod),
      donation.notes || '-',
    ];
    tableRows.push(donationData);
  });

  // Agregar fila de total si se proporciona
  if (totalFiltrado !== null) {
    tableRows.push([
      '',
      '',
      `$${totalFiltrado.toLocaleString('es-ES')}`,
      '',
      '',
      'TOTAL FILTRADO'
    ]);
  }

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 30,
    theme: 'grid',
    styles: {
      font: 'helvetica',
      fontSize: 10,
      cellPadding: 3,
      overflow: 'linebreak',
      halign: 'left',
      valign: 'middle'
    },
    headStyles: {
      fillColor: [240, 240, 240],
      textColor: [0, 0, 0],
      fontStyle: 'bold'
    },
    alternateRowStyles: {
      fillColor: [249, 249, 249]
    }
  });
  doc.save(`reporte_donaciones_${new Date().toISOString().slice(0,10)}.pdf`);
};

// Exportación de eventos con jsPDF/autotable
export const generateEventsPdf = (events) => {
  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text('Reporte de Eventos', 14, 22);

  const tableColumn = ["ID", "Socio", "Tipo de Evento", "Fecha del Evento", "Notas"];
  const tableRows = [];

  events.forEach(event => {
    const eventData = [
      event.id,
      event.memberName,
      traducirEvento(event.eventType),
      fechaCorta(event.eventDate),
      event.notes || '-',
    ];
    tableRows.push(eventData);
  });

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 30,
    theme: 'grid',
    styles: {
      font: 'helvetica',
      fontSize: 10,
      cellPadding: 3,
      overflow: 'linebreak',
      halign: 'left',
      valign: 'middle'
    },
    headStyles: {
      fillColor: [240, 240, 240],
      textColor: [0, 0, 0],
      fontStyle: 'bold'
    },
    alternateRowStyles: {
      fillColor: [249, 249, 249]
    }
  });
  doc.save(`reporte_eventos_${new Date().toISOString().slice(0,10)}.pdf`);
};

// Exportación de recordatorios con jsPDF/autotable
export const generateRemindersPdf = (reminders) => {
  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text('Reporte de Recordatorios', 14, 22);

  const tableColumn = ["ID", "Socio", "Tipo", "Fecha de Envío", "Asunto", "Mensaje"];
  const tableRows = [];

  reminders.forEach(reminder => {
    const reminderData = [
      reminder.id,
      reminder.memberName,
      traducirRecordatorio(reminder.reminderType),
      fechaCorta(reminder.sendDate),
      reminder.subject,
      reminder.message,
    ];
    tableRows.push(reminderData);
  });

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 30,
    theme: 'grid',
    styles: {
      font: 'helvetica',
      fontSize: 10,
      cellPadding: 3,
      overflow: 'linebreak',
      halign: 'left',
      valign: 'middle'
    },
    headStyles: {
      fillColor: [240, 240, 240],
      textColor: [0, 0, 0],
      fontStyle: 'bold'
    },
    alternateRowStyles: {
      fillColor: [249, 249, 249]
    }
  });
  doc.save(`reporte_recordatorios_${new Date().toISOString().slice(0,10)}.pdf`);
};